import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
// import isEmpty from 'lodash/isEmpty';
import * as types from '../actionTypes';
import * as urls from '../urlTypes';
import { _getDefinitionData, _setActiveDefinaction, _getLatestStudies } from '../../util/deUtils';
import { toastError } from '../../util/toastUtils';

export const encodeQueryParams = obj => {
  const sq = cloneDeep(obj);
  // Object.keys(sq).map(k => {
  //   if (!sq[k] || isEmpty(sq[k])) {
  //     delete sq[k];
  //   }
  //   return false;
  // });
  return Object.entries(sq)
    .map(e => e.join('='))
    .join('&');
};

export const resetDeState = () => dispatch => {
  dispatch({
    type: types.RESET_DE_STATE,
  });
  dispatch({
    type: types.RESET_DE_LABEL,
  });
  dispatch({
    type: types.RESET_DE_DISTRIBUTE,
  });
  dispatch({
    type: types.DE_RESET_IMPORT_SELECTION,
  });
};

// export const setActiveNav = navId => dispatch => {
//   dispatch(resetDeState());
//   dispatch({
//     type: types.SET_DE_ACTIVE_NAV,
//     navId,
//   });
//   dispatch({
//     type: types.RESET_TARGET_LABEL,
//   })
// };

export const _getDefinitionResponse = async (accountId, param) => {
  const sq = encodeQueryParams(param);
  let url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/list/${accountId}`;
  if (sq) {
    url = `${url}?${sq}`;
  }
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get data enablement target list');
    return false;
  }
};

export const setDeCTTableQuery = query => async dispatch => {
  dispatch({
    type: types.SET_DE_CT_TABLE_QUERY,
    query,
  });
};

export const getDeDefinitions = (
  accountId,
  param,
  isLoadMore = false
) => async (dispatch, getState) => {
  const state = getState();
  const deDefinitionStateData =
    state.deTargetDashboard.definition.response.data;
  dispatch(setDeCTTableQuery(param));
  if (!isLoadMore) {
    dispatch({
      type: types.RESET_QUERY_ON_SEARCH_SORT,
    });
    dispatch({
      type: types.GET_DE_DEFINITION_REQUEST,
    });
  }
  const definitionDataResponse = await _getDefinitionResponse(accountId, param);
  if (definitionDataResponse) {
    // merge currnet state and new data;
    const formattedDefinitionData = _getDefinitionData(
      definitionDataResponse.data
    );
    let data = formattedDefinitionData;
    if (definitionDataResponse.currentPage > 1) {
      data = [...deDefinitionStateData, ...formattedDefinitionData];
    }
    const response = {
      data,
      totalPages: definitionDataResponse.totalPages,
      currentPage: definitionDataResponse.currentPage,
      hasMorePages: definitionDataResponse.hasMorePages,
    };

    dispatch({
      type: types.GET_DE_DEFINITION_SUCCESS,
      response,
    });
  } else {
    dispatch({
      type: types.GET_DE_DEFINITION_FAILURE,
    });
  }
};

export const setSelectedTargets = (isSelected, row, isAll = false) => (
  dispatch,
  getState
) => {
  const state = getState();
  const deDefinitionData = state.deTargetDashboard.definition.response.data;

  const definitionData = _setActiveDefinaction(
    deDefinitionData,
    isSelected,
    row,
    isAll
  );
  const response = {
    ...state.deTargetDashboard.definition.response,
    data: definitionData,
  };

  dispatch({
    type: types.GET_DE_DEFINITION_SUCCESS,
    response,
  });
};

export const _getDeStudies = async (userId, accountId) => {
  const url = `${urls.API_GATEWAY_URL}/api/insights/users/${userId}/${accountId}/de-studies`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Definition studies');
    return false;
  }
};

export const getDeStudies = () => async (dispatch, getState) => {
  const state = getState();
  const userId = state.login.loginResponse.data.uid;
  const accountId = state.account.activeAccountId;

  dispatch({
    type: types.GET_DE_STUDY_REQUEST,
  });

  const studies = await _getDeStudies(userId, accountId);

  if (studies) {
    dispatch({
      type: types.GET_DE_STUDY_SUCCESS,
      data: studies.data,
    });
    const activeStudy = _getLatestStudies(studies.data);
    dispatch({
      type: types.UPDATE_WEIGHT_TYPES,
      payload: {
        moduleType: 'DATAHUB',
        weightTypeObj: activeStudy.cw[0],
      },
    });
  } else {
    dispatch({
      type: types.GET_DE_STUDY_FAILURE,
    });
  }
};

// set selected target in Label Screen
export const setTargetLabel = target => dispatch => {
  dispatch({
    type: types.SET_TARGET_LABEL,
    payload: target,
  });
};

export const _deleteTarget = async (accountId, reqParam) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/update/delete/${accountId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
      data: reqParam,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to delete target');
    return false;
  }
};

export const deleteTarget = (reqParam) => async (dispatch, getState) => {
  const { account, deTargetDashboard  } = getState();
  const accountId = account.activeAccountId;
  const response = await _deleteTarget(
    accountId,
    reqParam
  );
  if (response && response.success === 0) {
    const targetIndex = findIndex(deTargetDashboard.definition.response.data, elem => elem.id === response.id);
    delete deTargetDashboard.definition.response.data[targetIndex];
    const tempArr = [];
    deTargetDashboard.definition.response.data.map(row =>
      tempArr.push(row)
    )
    deTargetDashboard.definition.response.data = tempArr
    dispatch({
      type: types.GET_DE_DEFINITION_SUCCESS,
      response: deTargetDashboard.definition.response,
    });
  }
};